import { render, staticRenderFns } from "./AddDZ.vue?vue&type=template&id=a3574f58"
import script from "./AddDZ.vue?vue&type=script&lang=js"
export * from "./AddDZ.vue?vue&type=script&lang=js"
import style0 from "./AddDZ.vue?vue&type=style&index=0&id=a3574f58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports